// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/control_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DocumentSource } from "../../artifacts/v1/model_pb";
import { file_artifacts_v1_model } from "../../artifacts/v1/model_pb";
import type { AnalysisResult } from "../../controls/v1/analysis_result_pb";
import { file_controls_v1_analysis_result } from "../../controls/v1/analysis_result_pb";
import type { ControlCriteria } from "../../controls/v1/control_criteria_pb";
import { file_controls_v1_control_criteria } from "../../controls/v1/control_criteria_pb";
import type { ControlStatus } from "../../controls/v1/control_status_pb";
import { file_controls_v1_control_status } from "../../controls/v1/control_status_pb";
import type { SpecialControlType } from "../../controls/v1/special_control_type_pb";
import { file_controls_v1_special_control_type } from "../../controls/v1/special_control_type_pb";
import type { User } from "../../customer/management/v1/service_pb";
import { file_customer_management_v1_service } from "../../customer/management/v1/service_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Comment } from "./comment_pb";
import { file_inventory_v1_comment } from "./comment_pb";
import type { CompanySummary } from "./company_summary_pb";
import { file_inventory_v1_company_summary } from "./company_summary_pb";
import type { Documentation } from "./documentation_pb";
import { file_inventory_v1_documentation } from "./documentation_pb";
import type { Implication } from "./implication_pb";
import { file_inventory_v1_implication } from "./implication_pb";
import type { Scope } from "./scope_pb";
import { file_inventory_v1_scope } from "./scope_pb";
import type { QuestionnaireStatus } from "../../questionnaire/common/v1/questionnaire_status_pb";
import { file_questionnaire_common_v1_questionnaire_status } from "../../questionnaire/common/v1/questionnaire_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/control_service.proto.
 */
export const file_inventory_v1_control_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_artifacts_v1_model, file_controls_v1_analysis_result, file_controls_v1_control_criteria, file_controls_v1_control_status, file_controls_v1_special_control_type, file_customer_management_v1_service, file_google_protobuf_timestamp, file_inventory_v1_comment, file_inventory_v1_company_summary, file_inventory_v1_documentation, file_inventory_v1_implication, file_inventory_v1_scope, file_questionnaire_common_v1_questionnaire_status]);

/**
 * @generated from message inventory.v1.CreateOrUpdateOrgControlDefinitionRequest
 */
export type CreateOrUpdateOrgControlDefinitionRequest = Message<"inventory.v1.CreateOrUpdateOrgControlDefinitionRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * If control_definition_id is provided, the control definition will be
   * updated. Otherwise, a new control definition will be created.
   *
   * @generated from field: optional string control_definition_id = 2;
   */
  controlDefinitionId?: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string risk_description = 5;
   */
  riskDescription: string;

  /**
   * @generated from field: repeated string suggested_actions = 6;
   */
  suggestedActions: string[];

  /**
   * @generated from field: string llm_question = 7;
   */
  llmQuestion: string;

  /**
   * @generated from field: string display_question = 8;
   */
  displayQuestion: string;

  /**
   * @generated from field: string control_scope_id = 9;
   */
  controlScopeId: string;

  /**
   * @generated from field: string control_category_id = 10;
   */
  controlCategoryId: string;

  /**
   * @generated from field: controls.v1.ControlStatus default_status = 11;
   */
  defaultStatus: ControlStatus;

  /**
   * @generated from field: bool visible = 13;
   */
  visible: boolean;

  /**
   * @generated from field: repeated string subcategory_allow_list_ids = 14;
   */
  subcategoryAllowListIds: string[];

  /**
   * @generated from field: repeated string search_queries = 15;
   */
  searchQueries: string[];

  /**
   * @generated from field: int32 control_weight = 16;
   */
  controlWeight: number;

  /**
   * @generated from field: bool enabled = 17;
   */
  enabled: boolean;

  /**
   * When true, the control is evaluated by sending full documents as-is to a
   * long-context model, bypassing the vector store. Support-user only.
   *
   * @generated from field: bool is_full_document_control = 18;
   */
  isFullDocumentControl: boolean;

  /**
   * Per-status rubric that scores VALIDATED / GAP / NO_EVIDENCE outcomes.
   * Editable by support users; forwarded verbatim on create and update.
   *
   * @generated from field: optional controls.v1.ControlCriteria criteria = 19;
   */
  criteria?: ControlCriteria;
};

/**
 * Describes the message inventory.v1.CreateOrUpdateOrgControlDefinitionRequest.
 * Use `create(CreateOrUpdateOrgControlDefinitionRequestSchema)` to create a new message.
 */
export const CreateOrUpdateOrgControlDefinitionRequestSchema: GenMessage<CreateOrUpdateOrgControlDefinitionRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 0);

/**
 * @generated from message inventory.v1.CreateOrUpdateOrgControlDefinitionResponse
 */
export type CreateOrUpdateOrgControlDefinitionResponse = Message<"inventory.v1.CreateOrUpdateOrgControlDefinitionResponse"> & {
};

/**
 * Describes the message inventory.v1.CreateOrUpdateOrgControlDefinitionResponse.
 * Use `create(CreateOrUpdateOrgControlDefinitionResponseSchema)` to create a new message.
 */
export const CreateOrUpdateOrgControlDefinitionResponseSchema: GenMessage<CreateOrUpdateOrgControlDefinitionResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 1);

/**
 * @generated from message inventory.v1.CreateControlRequest
 */
export type CreateControlRequest = Message<"inventory.v1.CreateControlRequest"> & {
  /**
   * @generated from field: string control_title = 1;
   */
  controlTitle: string;

  /**
   * @generated from field: string control_display_question = 2;
   */
  controlDisplayQuestion: string;

  /**
   * @generated from field: string control_llm_question = 3;
   */
  controlLlmQuestion: string;

  /**
   * @generated from field: string control_category_id = 4;
   */
  controlCategoryId: string;

  /**
   * @generated from field: string control_scope_id = 5;
   */
  controlScopeId: string;

  /**
   * @generated from field: int32 control_weight = 6;
   */
  controlWeight: number;

  /**
   * @generated from field: bool enabled = 7;
   */
  enabled: boolean;

  /**
   * @generated from field: optional controls.v1.ControlCriteria criteria = 8;
   */
  criteria?: ControlCriteria;
};

/**
 * Describes the message inventory.v1.CreateControlRequest.
 * Use `create(CreateControlRequestSchema)` to create a new message.
 */
export const CreateControlRequestSchema: GenMessage<CreateControlRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 2);

/**
 * @generated from message inventory.v1.CreateControlResponse
 */
export type CreateControlResponse = Message<"inventory.v1.CreateControlResponse"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;
};

/**
 * Describes the message inventory.v1.CreateControlResponse.
 * Use `create(CreateControlResponseSchema)` to create a new message.
 */
export const CreateControlResponseSchema: GenMessage<CreateControlResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 3);

/**
 * @generated from message inventory.v1.DeleteControlRequest
 */
export type DeleteControlRequest = Message<"inventory.v1.DeleteControlRequest"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;
};

/**
 * Describes the message inventory.v1.DeleteControlRequest.
 * Use `create(DeleteControlRequestSchema)` to create a new message.
 */
export const DeleteControlRequestSchema: GenMessage<DeleteControlRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 4);

/**
 * @generated from message inventory.v1.DeleteControlResponse
 */
export type DeleteControlResponse = Message<"inventory.v1.DeleteControlResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteControlResponse.
 * Use `create(DeleteControlResponseSchema)` to create a new message.
 */
export const DeleteControlResponseSchema: GenMessage<DeleteControlResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 5);

/**
 * @generated from message inventory.v1.Control
 */
export type Control = Message<"inventory.v1.Control"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string category_name = 2;
   */
  categoryName: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: controls.v1.ControlStatus status = 5;
   */
  status: ControlStatus;

  /**
   * @generated from field: bool is_enabled = 6;
   */
  isEnabled: boolean;

  /**
   * @generated from field: int32 order_priority = 7;
   */
  orderPriority: number;

  /**
   * @generated from field: repeated string frameworks = 8;
   */
  frameworks: string[];

  /**
   * @generated from field: optional inventory.v1.Scope scope = 9;
   */
  scope?: Scope;

  /**
   * @generated from field: inventory.v1.SmartQuestion smart_question = 10;
   */
  smartQuestion?: SmartQuestion;

  /**
   * @generated from field: optional string ongoing_assessment_id = 11;
   */
  ongoingAssessmentId?: string;

  /**
   * @generated from field: repeated string subcategory_allow_list_ids = 12;
   */
  subcategoryAllowListIds: string[];

  /**
   * @generated from field: string display_question = 13;
   */
  displayQuestion: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_calculated_at = 14;
   */
  lastCalculatedAt?: Timestamp;

  /**
   * @generated from field: optional string latest_assessment_name = 15;
   */
  latestAssessmentName?: string;

  /**
   * @generated from field: bool is_up_to_date = 16;
   */
  isUpToDate: boolean;

  /**
   * @generated from field: int32 control_weight = 18;
   */
  controlWeight: number;

  /**
   * For backward compatibility in past assessments
   *
   * @generated from field: string control_scope_name = 19;
   */
  controlScopeName: string;

  /**
   * Global cross-tenant control definition ID. Absent for controls that
   * don't derive from a global ControlDefinition template.
   *
   * @generated from field: optional string control_definition_id = 20;
   */
  controlDefinitionId?: string;

  /**
   * @generated from field: controls.v1.SpecialControlType special_type = 21;
   */
  specialType: SpecialControlType;
};

/**
 * Describes the message inventory.v1.Control.
 * Use `create(ControlSchema)` to create a new message.
 */
export const ControlSchema: GenMessage<Control> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 6);

/**
 * @generated from message inventory.v1.SmartQuestion
 */
export type SmartQuestion = Message<"inventory.v1.SmartQuestion"> & {
  /**
   * @generated from field: int32 comment_count = 1;
   */
  commentCount: number;

  /**
   * @generated from field: inventory.v1.SmartQuestionStatus status = 2;
   */
  status: SmartQuestionStatus;

  /**
   * Set when status is AWAITING_REVIEW: the recipient's latest response and when
   * it happened. Drives the "Accepted · 1h ago" line under the "Ready For Review"
   * badge on the Assessment Issues tab.
   *
   * @generated from field: optional inventory.v1.SmartEvidenceResponseType last_response_type = 3;
   */
  lastResponseType?: SmartEvidenceResponseType;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_response_at = 4;
   */
  lastResponseAt?: Timestamp;

  /**
   * True when this user has opened the control Activity tab since the latest comment.
   *
   * @generated from field: bool comments_viewed = 5;
   */
  commentsViewed: boolean;
};

/**
 * Describes the message inventory.v1.SmartQuestion.
 * Use `create(SmartQuestionSchema)` to create a new message.
 */
export const SmartQuestionSchema: GenMessage<SmartQuestion> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 7);

/**
 * @generated from message inventory.v1.MarkControlCommentsViewedRequest
 */
export type MarkControlCommentsViewedRequest = Message<"inventory.v1.MarkControlCommentsViewedRequest"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;
};

/**
 * Describes the message inventory.v1.MarkControlCommentsViewedRequest.
 * Use `create(MarkControlCommentsViewedRequestSchema)` to create a new message.
 */
export const MarkControlCommentsViewedRequestSchema: GenMessage<MarkControlCommentsViewedRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 8);

/**
 * @generated from message inventory.v1.MarkControlCommentsViewedResponse
 */
export type MarkControlCommentsViewedResponse = Message<"inventory.v1.MarkControlCommentsViewedResponse"> & {
};

/**
 * Describes the message inventory.v1.MarkControlCommentsViewedResponse.
 * Use `create(MarkControlCommentsViewedResponseSchema)` to create a new message.
 */
export const MarkControlCommentsViewedResponseSchema: GenMessage<MarkControlCommentsViewedResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 9);

/**
 * @generated from message inventory.v1.UpdateControlSettingsResponse
 */
export type UpdateControlSettingsResponse = Message<"inventory.v1.UpdateControlSettingsResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateControlSettingsResponse.
 * Use `create(UpdateControlSettingsResponseSchema)` to create a new message.
 */
export const UpdateControlSettingsResponseSchema: GenMessage<UpdateControlSettingsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 10);

/**
 * @generated from message inventory.v1.UpdateControlSettingsRequest
 */
export type UpdateControlSettingsRequest = Message<"inventory.v1.UpdateControlSettingsRequest"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;

  /**
   * @generated from field: optional string control_scope_id = 2;
   */
  controlScopeId?: string;

  /**
   * @generated from field: int32 control_weight = 3;
   */
  controlWeight: number;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * @generated from field: bool visible = 5;
   */
  visible: boolean;

  /**
   * @generated from field: optional string control_category_id = 6;
   */
  controlCategoryId?: string;

  /**
   * @generated from field: optional string control_title = 7;
   */
  controlTitle?: string;
};

/**
 * Describes the message inventory.v1.UpdateControlSettingsRequest.
 * Use `create(UpdateControlSettingsRequestSchema)` to create a new message.
 */
export const UpdateControlSettingsRequestSchema: GenMessage<UpdateControlSettingsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 11);

/**
 * @generated from message inventory.v1.ControlStatusCommentSetting
 */
export type ControlStatusCommentSetting = Message<"inventory.v1.ControlStatusCommentSetting"> & {
  /**
   * @generated from field: bool require_comment_on_status_change = 1;
   */
  requireCommentOnStatusChange: boolean;
};

/**
 * Describes the message inventory.v1.ControlStatusCommentSetting.
 * Use `create(ControlStatusCommentSettingSchema)` to create a new message.
 */
export const ControlStatusCommentSettingSchema: GenMessage<ControlStatusCommentSetting> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 12);

/**
 * @generated from message inventory.v1.GetControlStatusCommentSettingRequest
 */
export type GetControlStatusCommentSettingRequest = Message<"inventory.v1.GetControlStatusCommentSettingRequest"> & {
};

/**
 * Describes the message inventory.v1.GetControlStatusCommentSettingRequest.
 * Use `create(GetControlStatusCommentSettingRequestSchema)` to create a new message.
 */
export const GetControlStatusCommentSettingRequestSchema: GenMessage<GetControlStatusCommentSettingRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 13);

/**
 * @generated from message inventory.v1.GetControlStatusCommentSettingResponse
 */
export type GetControlStatusCommentSettingResponse = Message<"inventory.v1.GetControlStatusCommentSettingResponse"> & {
  /**
   * @generated from field: inventory.v1.ControlStatusCommentSetting setting = 1;
   */
  setting?: ControlStatusCommentSetting;
};

/**
 * Describes the message inventory.v1.GetControlStatusCommentSettingResponse.
 * Use `create(GetControlStatusCommentSettingResponseSchema)` to create a new message.
 */
export const GetControlStatusCommentSettingResponseSchema: GenMessage<GetControlStatusCommentSettingResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 14);

/**
 * @generated from message inventory.v1.SetControlStatusCommentSettingRequest
 */
export type SetControlStatusCommentSettingRequest = Message<"inventory.v1.SetControlStatusCommentSettingRequest"> & {
  /**
   * @generated from field: bool require_comment_on_status_change = 1;
   */
  requireCommentOnStatusChange: boolean;
};

/**
 * Describes the message inventory.v1.SetControlStatusCommentSettingRequest.
 * Use `create(SetControlStatusCommentSettingRequestSchema)` to create a new message.
 */
export const SetControlStatusCommentSettingRequestSchema: GenMessage<SetControlStatusCommentSettingRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 15);

/**
 * @generated from message inventory.v1.SetControlStatusCommentSettingResponse
 */
export type SetControlStatusCommentSettingResponse = Message<"inventory.v1.SetControlStatusCommentSettingResponse"> & {
};

/**
 * Describes the message inventory.v1.SetControlStatusCommentSettingResponse.
 * Use `create(SetControlStatusCommentSettingResponseSchema)` to create a new message.
 */
export const SetControlStatusCommentSettingResponseSchema: GenMessage<SetControlStatusCommentSettingResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 16);

/**
 * @generated from message inventory.v1.ListControlSettingsRequest
 */
export type ListControlSettingsRequest = Message<"inventory.v1.ListControlSettingsRequest"> & {
};

/**
 * Describes the message inventory.v1.ListControlSettingsRequest.
 * Use `create(ListControlSettingsRequestSchema)` to create a new message.
 */
export const ListControlSettingsRequestSchema: GenMessage<ListControlSettingsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 17);

/**
 * @generated from message inventory.v1.ListControlSettingsResponse
 */
export type ListControlSettingsResponse = Message<"inventory.v1.ListControlSettingsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.ControlSetting control_settings = 1;
   */
  controlSettings: ControlSetting[];
};

/**
 * Describes the message inventory.v1.ListControlSettingsResponse.
 * Use `create(ListControlSettingsResponseSchema)` to create a new message.
 */
export const ListControlSettingsResponseSchema: GenMessage<ListControlSettingsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 18);

/**
 * @generated from message inventory.v1.ControlSetting
 */
export type ControlSetting = Message<"inventory.v1.ControlSetting"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;

  /**
   * @generated from field: string category_name = 2;
   */
  categoryName: string;

  /**
   * @generated from field: string control_title = 3;
   */
  controlTitle: string;

  /**
   * @generated from field: int32 order_priority = 4;
   */
  orderPriority: number;

  /**
   * @generated from field: inventory.v1.Scope scope = 5;
   */
  scope?: Scope;

  /**
   * @generated from field: repeated string control_suggested_actions = 6;
   */
  controlSuggestedActions: string[];

  /**
   * @generated from field: string control_llm_question = 7;
   */
  controlLlmQuestion: string;

  /**
   * @generated from field: string control_display_question = 8;
   */
  controlDisplayQuestion: string;

  /**
   * @generated from field: string control_control_category_id = 9;
   */
  controlControlCategoryId: string;

  /**
   * @generated from field: controls.v1.ControlStatus control_default_status = 10;
   */
  controlDefaultStatus: ControlStatus;

  /**
   * @generated from field: bool visible = 11;
   */
  visible: boolean;

  /**
   * @generated from field: repeated string subcategory_allow_list_ids = 12;
   */
  subcategoryAllowListIds: string[];

  /**
   * @generated from field: repeated string search_queries = 13;
   */
  searchQueries: string[];

  /**
   * @generated from field: int32 control_weight = 14;
   */
  controlWeight: number;

  /**
   * @generated from field: bool enabled = 15;
   */
  enabled: boolean;

  /**
   * @generated from field: bool is_full_document_control = 16;
   */
  isFullDocumentControl: boolean;

  /**
   * @generated from field: optional controls.v1.ControlCriteria criteria = 17;
   */
  criteria?: ControlCriteria;

  /**
   * @generated from field: bool is_custom = 18;
   */
  isCustom: boolean;

  /**
   * @generated from field: customer.management.v1.User created_by = 19;
   */
  createdBy?: User;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: customer.management.v1.User last_updated_by = 21;
   */
  lastUpdatedBy?: User;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_at = 22;
   */
  lastUpdatedAt?: Timestamp;

  /**
   * @generated from field: controls.v1.SpecialControlType special_type = 23;
   */
  specialType: SpecialControlType;
};

/**
 * Describes the message inventory.v1.ControlSetting.
 * Use `create(ControlSettingSchema)` to create a new message.
 */
export const ControlSettingSchema: GenMessage<ControlSetting> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 19);

/**
 * @generated from message inventory.v1.ListControlsRequest
 */
export type ListControlsRequest = Message<"inventory.v1.ListControlsRequest"> & {
  /**
   * @generated from field: string assessment_id = 2;
   */
  assessmentId: string;
};

/**
 * Describes the message inventory.v1.ListControlsRequest.
 * Use `create(ListControlsRequestSchema)` to create a new message.
 */
export const ListControlsRequestSchema: GenMessage<ListControlsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 20);

/**
 * @generated from message inventory.v1.ListControlsResponse
 */
export type ListControlsResponse = Message<"inventory.v1.ListControlsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Control controls = 1;
   */
  controls: Control[];
};

/**
 * Describes the message inventory.v1.ListControlsResponse.
 * Use `create(ListControlsResponseSchema)` to create a new message.
 */
export const ListControlsResponseSchema: GenMessage<ListControlsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 21);

/**
 * @generated from message inventory.v1.GetControlRequest
 */
export type GetControlRequest = Message<"inventory.v1.GetControlRequest"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;

  /**
   * @generated from field: optional bool static_output = 2;
   */
  staticOutput?: boolean;
};

/**
 * Describes the message inventory.v1.GetControlRequest.
 * Use `create(GetControlRequestSchema)` to create a new message.
 */
export const GetControlRequestSchema: GenMessage<GetControlRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 22);

/**
 * @generated from message inventory.v1.GetControlResponse
 */
export type GetControlResponse = Message<"inventory.v1.GetControlResponse"> & {
  /**
   * @generated from field: inventory.v1.Control control = 1;
   */
  control?: Control;

  /**
   * @generated from field: string control_definition = 2;
   */
  controlDefinition: string;

  /**
   * @generated from field: controls.v1.AnalysisResult analysis_result = 3;
   */
  analysisResult?: AnalysisResult;

  /**
   * @generated from field: inventory.v1.CompanySummary company = 4;
   */
  company?: CompanySummary;

  /**
   * @generated from field: repeated string signal_ids = 5;
   */
  signalIds: string[];

  /**
   * @generated from field: inventory.v1.Documentation documentation = 6;
   */
  documentation?: Documentation;

  /**
   * @generated from field: string org_control_definition_id = 7;
   */
  orgControlDefinitionId: string;

  /**
   * @generated from field: bool manual_status = 8;
   */
  manualStatus: boolean;

  /**
   * Global cross-tenant control definition ID. Absent for controls that
   * don't derive from a global ControlDefinition template.
   *
   * @generated from field: optional string control_definition_id = 9;
   */
  controlDefinitionId?: string;

  /**
   * True when the vendor-attestation classifier set the status rather than a reviewer.
   * manual_status is true for both, since each writes a status-change row.
   *
   * @generated from field: bool ai_attested = 10;
   */
  aiAttested: boolean;
};

/**
 * Describes the message inventory.v1.GetControlResponse.
 * Use `create(GetControlResponseSchema)` to create a new message.
 */
export const GetControlResponseSchema: GenMessage<GetControlResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 23);

/**
 * @generated from message inventory.v1.UpdateControlRequest
 */
export type UpdateControlRequest = Message<"inventory.v1.UpdateControlRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional controls.v1.ControlStatus status = 2;
   */
  status?: ControlStatus;

  /**
   * @generated from field: optional string comment = 3;
   */
  comment?: string;

  /**
   * @generated from field: optional inventory.v1.ControlStatusChangeReason reason = 4;
   */
  reason?: ControlStatusChangeReason;
};

/**
 * Describes the message inventory.v1.UpdateControlRequest.
 * Use `create(UpdateControlRequestSchema)` to create a new message.
 */
export const UpdateControlRequestSchema: GenMessage<UpdateControlRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 24);

/**
 * @generated from message inventory.v1.UpdateControlResponse
 */
export type UpdateControlResponse = Message<"inventory.v1.UpdateControlResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateControlResponse.
 * Use `create(UpdateControlResponseSchema)` to create a new message.
 */
export const UpdateControlResponseSchema: GenMessage<UpdateControlResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 25);

/**
 * @generated from message inventory.v1.GetControlTimelineRequest
 */
export type GetControlTimelineRequest = Message<"inventory.v1.GetControlTimelineRequest"> & {
  /**
   * @generated from field: string control_id = 1;
   */
  controlId: string;
};

/**
 * Describes the message inventory.v1.GetControlTimelineRequest.
 * Use `create(GetControlTimelineRequestSchema)` to create a new message.
 */
export const GetControlTimelineRequestSchema: GenMessage<GetControlTimelineRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 26);

/**
 * @generated from message inventory.v1.GetControlTimelineResponse
 */
export type GetControlTimelineResponse = Message<"inventory.v1.GetControlTimelineResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.ControlTimelineItem items = 1;
   */
  items: ControlTimelineItem[];
};

/**
 * Describes the message inventory.v1.GetControlTimelineResponse.
 * Use `create(GetControlTimelineResponseSchema)` to create a new message.
 */
export const GetControlTimelineResponseSchema: GenMessage<GetControlTimelineResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 27);

/**
 * @generated from message inventory.v1.ControlTimelineItem
 */
export type ControlTimelineItem = Message<"inventory.v1.ControlTimelineItem"> & {
  /**
   * @generated from oneof inventory.v1.ControlTimelineItem.timeline_item
   */
  timelineItem: {
    /**
     * @generated from field: inventory.v1.ControlChange change = 1;
     */
    value: ControlChange;
    case: "change";
  } | {
    /**
     * @generated from field: inventory.v1.Comment comment = 2;
     */
    value: Comment;
    case: "comment";
  } | {
    /**
     * @generated from field: inventory.v1.RiskQuestionnaireControlThread risk_questionnaire_control_thread = 3;
     */
    value: RiskQuestionnaireControlThread;
    case: "riskQuestionnaireControlThread";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.ControlTimelineItem.
 * Use `create(ControlTimelineItemSchema)` to create a new message.
 */
export const ControlTimelineItemSchema: GenMessage<ControlTimelineItem> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 28);

/**
 * @generated from message inventory.v1.ControlChange
 */
export type ControlChange = Message<"inventory.v1.ControlChange"> & {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * @generated from field: controls.v1.ControlStatus prev_status = 2;
   */
  prevStatus: ControlStatus;

  /**
   * @generated from field: controls.v1.ControlStatus new_status = 3;
   */
  newStatus: ControlStatus;

  /**
   * @generated from field: optional inventory.v1.Comment comment = 6;
   */
  comment?: Comment;

  /**
   * @generated from field: string user_id = 7;
   */
  userId: string;

  /**
   * @generated from field: optional string vendor_notes_summary = 8;
   */
  vendorNotesSummary?: string;
};

/**
 * Describes the message inventory.v1.ControlChange.
 * Use `create(ControlChangeSchema)` to create a new message.
 */
export const ControlChangeSchema: GenMessage<ControlChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 29);

/**
 * @generated from message inventory.v1.ControlCountStat
 */
export type ControlCountStat = Message<"inventory.v1.ControlCountStat"> & {
  /**
   * @generated from field: controls.v1.ControlStatus status = 1;
   */
  status: ControlStatus;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message inventory.v1.ControlCountStat.
 * Use `create(ControlCountStatSchema)` to create a new message.
 */
export const ControlCountStatSchema: GenMessage<ControlCountStat> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 30);

/**
 * @generated from message inventory.v1.RiskQuestionnaireControlThread
 */
export type RiskQuestionnaireControlThread = Message<"inventory.v1.RiskQuestionnaireControlThread"> & {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: repeated controls.v1.AnalysisResult analysis_results = 3;
   */
  analysisResults: AnalysisResult[];

  /**
   * @generated from field: repeated inventory.v1.RiskQuestionnaireQuestionThreadActivity activities = 5;
   */
  activities: RiskQuestionnaireQuestionThreadActivity[];
};

/**
 * Describes the message inventory.v1.RiskQuestionnaireControlThread.
 * Use `create(RiskQuestionnaireControlThreadSchema)` to create a new message.
 */
export const RiskQuestionnaireControlThreadSchema: GenMessage<RiskQuestionnaireControlThread> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 31);

/**
 * @generated from message inventory.v1.RiskQuestionnaireQuestionThreadActivity
 */
export type RiskQuestionnaireQuestionThreadActivity = Message<"inventory.v1.RiskQuestionnaireQuestionThreadActivity"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof inventory.v1.RiskQuestionnaireQuestionThreadActivity.user_id
   */
  userId: {
    /**
     * @generated from field: string assessor_user_id = 2;
     */
    value: string;
    case: "assessorUserId";
  } | {
    /**
     * @generated from field: string recipient_id = 3;
     */
    value: string;
    case: "recipientId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string comment = 4;
   */
  comment?: string;

  /**
   * @generated from field: optional bool is_lema_suggestion_accepted = 5;
   */
  isLemaSuggestionAccepted?: boolean;

  /**
   * @generated from field: optional bool marked_as_resolved = 6;
   */
  markedAsResolved?: boolean;

  /**
   * @generated from field: string user_name = 7;
   */
  userName: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional questionnaire.common.v1.QuestionnaireStatus questionnaire_status = 9;
   */
  questionnaireStatus?: QuestionnaireStatus;

  /**
   * Resolved server-side so a portal recipient who is also a tenant user renders
   * with the same name and avatar as their comments elsewhere in the timeline.
   *
   * @generated from field: optional string avatar_url = 10;
   */
  avatarUrl?: string;

  /**
   * Set when the comment's live copy is a Liveblocks thread; clients render the thread instead of the stored text.
   *
   * @generated from field: optional string liveblocks_thread_id = 11;
   */
  liveblocksThreadId?: string;
};

/**
 * Describes the message inventory.v1.RiskQuestionnaireQuestionThreadActivity.
 * Use `create(RiskQuestionnaireQuestionThreadActivitySchema)` to create a new message.
 */
export const RiskQuestionnaireQuestionThreadActivitySchema: GenMessage<RiskQuestionnaireQuestionThreadActivity> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 32);

/**
 * @generated from message inventory.v1.FactTypeToControlTypeOption
 */
export type FactTypeToControlTypeOption = Message<"inventory.v1.FactTypeToControlTypeOption"> & {
  /**
   * @generated from field: string fact_type_id = 1;
   */
  factTypeId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: repeated string exclude_from_control_ids = 3;
   */
  excludeFromControlIds: string[];
};

/**
 * Describes the message inventory.v1.FactTypeToControlTypeOption.
 * Use `create(FactTypeToControlTypeOptionSchema)` to create a new message.
 */
export const FactTypeToControlTypeOptionSchema: GenMessage<FactTypeToControlTypeOption> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 33);

/**
 * @generated from message inventory.v1.DocumentFact
 */
export type DocumentFact = Message<"inventory.v1.DocumentFact"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string subcategory = 2;
   */
  subcategory?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 3;
   */
  expirationDate?: Timestamp;

  /**
   * @generated from field: string link = 4;
   */
  link: string;

  /**
   * @generated from field: repeated string quotes = 5;
   */
  quotes: string[];

  /**
   * @generated from field: optional int32 page = 6;
   */
  page?: number;

  /**
   * @generated from field: artifacts.v1.DocumentSource source = 7;
   */
  source: DocumentSource;

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 8;
   */
  uploadedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.DocumentFact.
 * Use `create(DocumentFactSchema)` to create a new message.
 */
export const DocumentFactSchema: GenMessage<DocumentFact> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 34);

/**
 * @generated from message inventory.v1.Fact
 */
export type Fact = Message<"inventory.v1.Fact"> & {
  /**
   * @generated from oneof inventory.v1.Fact.fact
   */
  fact: {
    /**
     * @generated from field: inventory.v1.DocumentFact document_fact = 1;
     */
    value: DocumentFact;
    case: "documentFact";
  } | {
    /**
     * @generated from field: string markdown = 2;
     */
    value: string;
    case: "markdown";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.Fact.
 * Use `create(FactSchema)` to create a new message.
 */
export const FactSchema: GenMessage<Fact> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 35);

/**
 * @generated from message inventory.v1.ListControlCategoriesRequest
 */
export type ListControlCategoriesRequest = Message<"inventory.v1.ListControlCategoriesRequest"> & {
};

/**
 * Describes the message inventory.v1.ListControlCategoriesRequest.
 * Use `create(ListControlCategoriesRequestSchema)` to create a new message.
 */
export const ListControlCategoriesRequestSchema: GenMessage<ListControlCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 36);

/**
 * @generated from message inventory.v1.ListControlCategoriesResponse
 */
export type ListControlCategoriesResponse = Message<"inventory.v1.ListControlCategoriesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.ControlCategory control_categories = 1;
   */
  controlCategories: ControlCategory[];
};

/**
 * Describes the message inventory.v1.ListControlCategoriesResponse.
 * Use `create(ListControlCategoriesResponseSchema)` to create a new message.
 */
export const ListControlCategoriesResponseSchema: GenMessage<ListControlCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 37);

/**
 * @generated from message inventory.v1.ControlCategory
 */
export type ControlCategory = Message<"inventory.v1.ControlCategory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.ControlCategory.
 * Use `create(ControlCategorySchema)` to create a new message.
 */
export const ControlCategorySchema: GenMessage<ControlCategory> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 38);

/**
 * NOTE: This patch ensures compatibility with assessments using legacy control definitions.
 * TODO: Remove after inventory model types are properly versioned and no longer
 * depend on inventory/v1.
 *
 * @generated from message inventory.v1.OldGetControlResponseV1
 */
export type OldGetControlResponseV1 = Message<"inventory.v1.OldGetControlResponseV1"> & {
  /**
   * @generated from field: inventory.v1.Control control = 1;
   */
  control?: Control;

  /**
   * @generated from field: string fact_title = 2;
   */
  factTitle: string;

  /**
   * @generated from field: repeated string signal_ids = 3;
   */
  signalIds: string[];

  /**
   * @generated from field: string fact_markdown = 4;
   */
  factMarkdown: string;

  /**
   * @generated from field: inventory.v1.CompanySummary company = 6;
   */
  company?: CompanySummary;

  /**
   * @generated from field: repeated inventory.v1.Implication implications = 7;
   */
  implications: Implication[];

  /**
   * @generated from field: string additional_fact_markdown = 8;
   */
  additionalFactMarkdown: string;

  /**
   * @generated from field: int32 additional_fact_count = 9;
   */
  additionalFactCount: number;

  /**
   * @generated from field: inventory.v1.Documentation documentation = 10;
   */
  documentation?: Documentation;
};

/**
 * Describes the message inventory.v1.OldGetControlResponseV1.
 * Use `create(OldGetControlResponseV1Schema)` to create a new message.
 */
export const OldGetControlResponseV1Schema: GenMessage<OldGetControlResponseV1> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 39);

/**
 * @generated from message inventory.v1.OldGetControlResponseV2
 */
export type OldGetControlResponseV2 = Message<"inventory.v1.OldGetControlResponseV2"> & {
  /**
   * @generated from field: inventory.v1.Control control = 1;
   */
  control?: Control;

  /**
   * @generated from field: string fact_title = 2;
   */
  factTitle: string;

  /**
   * @generated from field: repeated string signal_ids = 3;
   */
  signalIds: string[];

  /**
   * @generated from field: repeated inventory.v1.Fact facts = 4;
   */
  facts: Fact[];

  /**
   * @generated from field: inventory.v1.CompanySummary company = 6;
   */
  company?: CompanySummary;

  /**
   * @generated from field: repeated inventory.v1.Implication implications = 7;
   */
  implications: Implication[];

  /**
   * @generated from field: repeated inventory.v1.Fact additional_facts = 8;
   */
  additionalFacts: Fact[];

  /**
   * @generated from field: inventory.v1.Documentation documentation = 10;
   */
  documentation?: Documentation;
};

/**
 * Describes the message inventory.v1.OldGetControlResponseV2.
 * Use `create(OldGetControlResponseV2Schema)` to create a new message.
 */
export const OldGetControlResponseV2Schema: GenMessage<OldGetControlResponseV2> = /*@__PURE__*/
  messageDesc(file_inventory_v1_control_service, 40);

/**
 * SmartEvidenceResponseType is the recipient's latest action on a smart-evidence
 * request, derived from the thread activity's lema_suggestion_accepted.
 *
 * @generated from enum inventory.v1.SmartEvidenceResponseType
 */
export enum SmartEvidenceResponseType {
  /**
   * @generated from enum value: SMART_EVIDENCE_RESPONSE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * lema_suggestion_accepted = true
   *
   * @generated from enum value: SMART_EVIDENCE_RESPONSE_TYPE_ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * lema_suggestion_accepted = false
   *
   * @generated from enum value: SMART_EVIDENCE_RESPONSE_TYPE_REJECTED = 2;
   */
  REJECTED = 2,

  /**
   * comment, no suggestion accept/reject
   *
   * @generated from enum value: SMART_EVIDENCE_RESPONSE_TYPE_COMMENTED = 3;
   */
  COMMENTED = 3,
}

/**
 * Describes the enum inventory.v1.SmartEvidenceResponseType.
 */
export const SmartEvidenceResponseTypeSchema: GenEnum<SmartEvidenceResponseType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_control_service, 0);

/**
 * @generated from enum inventory.v1.SmartQuestionStatus
 */
export enum SmartQuestionStatus {
  /**
   * @generated from enum value: SMART_QUESTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SMART_QUESTION_STATUS_UNPUBLISHED = 1;
   */
  UNPUBLISHED = 1,

  /**
   * @generated from enum value: SMART_QUESTION_STATUS_PUBLISHED = 2;
   */
  PUBLISHED = 2,

  /**
   * @generated from enum value: SMART_QUESTION_STATUS_AWAITING_REVIEW = 3;
   */
  AWAITING_REVIEW = 3,

  /**
   * @generated from enum value: SMART_QUESTION_STATUS_AWAITING_RECIPIENT = 4;
   */
  AWAITING_RECIPIENT = 4,

  /**
   * @generated from enum value: SMART_QUESTION_STATUS_RESOLVED = 5;
   */
  RESOLVED = 5,

  /**
   * @generated from enum value: SMART_QUESTION_STATUS_AWAITING_REOPEN = 6;
   */
  AWAITING_REOPEN = 6,
}

/**
 * Describes the enum inventory.v1.SmartQuestionStatus.
 */
export const SmartQuestionStatusSchema: GenEnum<SmartQuestionStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_control_service, 1);

/**
 * @generated from enum inventory.v1.ControlStatusChangeReason
 */
export enum ControlStatusChangeReason {
  /**
   * @generated from enum value: CONTROL_STATUS_CHANGE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTROL_STATUS_CHANGE_REASON_BUSINESS_DECISION = 1;
   */
  BUSINESS_DECISION = 1,

  /**
   * @generated from enum value: CONTROL_STATUS_CHANGE_REASON_INCORRECT_AI_EVALUATION = 2;
   */
  INCORRECT_AI_EVALUATION = 2,

  /**
   * @generated from enum value: CONTROL_STATUS_CHANGE_REASON_VENDOR_ATTESTED = 3;
   */
  VENDOR_ATTESTED = 3,
}

/**
 * Describes the enum inventory.v1.ControlStatusChangeReason.
 */
export const ControlStatusChangeReasonSchema: GenEnum<ControlStatusChangeReason> = /*@__PURE__*/
  enumDesc(file_inventory_v1_control_service, 2);

/**
 * @generated from enum inventory.v1.InherentRiskSetting
 */
export enum InherentRiskSetting {
  /**
   * @generated from enum value: INHERENT_RISK_SETTING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INHERENT_RISK_SETTING_LOW_AND_ABOVE = 1;
   */
  LOW_AND_ABOVE = 1,

  /**
   * @generated from enum value: INHERENT_RISK_SETTING_MEDIUM_AND_ABOVE = 2;
   */
  MEDIUM_AND_ABOVE = 2,

  /**
   * @generated from enum value: INHERENT_RISK_SETTING_HIGH_AND_ABOVE = 3;
   */
  HIGH_AND_ABOVE = 3,

  /**
   * @generated from enum value: INHERENT_RISK_SETTING_CRITICAL_AND_ABOVE = 4;
   */
  CRITICAL_AND_ABOVE = 4,
}

/**
 * Describes the enum inventory.v1.InherentRiskSetting.
 */
export const InherentRiskSettingSchema: GenEnum<InherentRiskSetting> = /*@__PURE__*/
  enumDesc(file_inventory_v1_control_service, 3);

/**
 * @generated from service inventory.v1.ControlInventoryService
 */
export const ControlInventoryService: GenService<{
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.ListControlSettings
   */
  listControlSettings: {
    methodKind: "unary";
    input: typeof ListControlSettingsRequestSchema;
    output: typeof ListControlSettingsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.UpdateControlSettings
   */
  updateControlSettings: {
    methodKind: "unary";
    input: typeof UpdateControlSettingsRequestSchema;
    output: typeof UpdateControlSettingsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.GetControlStatusCommentSetting
   */
  getControlStatusCommentSetting: {
    methodKind: "unary";
    input: typeof GetControlStatusCommentSettingRequestSchema;
    output: typeof GetControlStatusCommentSettingResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.SetControlStatusCommentSetting
   */
  setControlStatusCommentSetting: {
    methodKind: "unary";
    input: typeof SetControlStatusCommentSettingRequestSchema;
    output: typeof SetControlStatusCommentSettingResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.CreateOrUpdateOrgControlDefinition
   */
  createOrUpdateOrgControlDefinition: {
    methodKind: "unary";
    input: typeof CreateOrUpdateOrgControlDefinitionRequestSchema;
    output: typeof CreateOrUpdateOrgControlDefinitionResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.CreateControl
   */
  createControl: {
    methodKind: "unary";
    input: typeof CreateControlRequestSchema;
    output: typeof CreateControlResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.DeleteControl
   */
  deleteControl: {
    methodKind: "unary";
    input: typeof DeleteControlRequestSchema;
    output: typeof DeleteControlResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.ListControls
   */
  listControls: {
    methodKind: "unary";
    input: typeof ListControlsRequestSchema;
    output: typeof ListControlsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.GetControl
   */
  getControl: {
    methodKind: "unary";
    input: typeof GetControlRequestSchema;
    output: typeof GetControlResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.UpdateControl
   */
  updateControl: {
    methodKind: "unary";
    input: typeof UpdateControlRequestSchema;
    output: typeof UpdateControlResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.GetControlTimeline
   */
  getControlTimeline: {
    methodKind: "unary";
    input: typeof GetControlTimelineRequestSchema;
    output: typeof GetControlTimelineResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.ControlInventoryService.ListControlCategories
   */
  listControlCategories: {
    methodKind: "unary";
    input: typeof ListControlCategoriesRequestSchema;
    output: typeof ListControlCategoriesResponseSchema;
  },
  /**
   * Records that the current user opened the control Activity tab. A later comment makes the indicator stand out again.
   *
   * @generated from rpc inventory.v1.ControlInventoryService.MarkControlCommentsViewed
   */
  markControlCommentsViewed: {
    methodKind: "unary";
    input: typeof MarkControlCommentsViewedRequestSchema;
    output: typeof MarkControlCommentsViewedResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_control_service, 0);

